import Link from 'next/link';
import Pill, { PillTheme, pillThemeColors } from '@/components/UI/Pill';
import Button, { ButtonSize, ButtonType } from '@/components/UI/buttons/Button';

interface Props {
  coverImageUrl: string;
  headline?: string;
  pillText?: string;
  ctaLink?: string;
  lowerText?: string;
  pillTheme?: PillTheme;
  pillPulse?: boolean;
}

export const HighlightCTA = ({
  headline,
  coverImageUrl,
  ctaLink,
  lowerText,
  pillText,
  pillPulse = false,
  pillTheme = PillTheme.NEUTRAL,
}: Props) => {
  const { primary } = pillThemeColors[pillTheme];
  const borderColor = pillTheme === PillTheme.GREEN ? 'white' : primary;

  const content = (
    <div className="bg-gridOverlay aspect-w-16 aspect-h-9 relative flex h-[400px] w-full flex-col items-center justify-center overflow-hidden rounded-3xl p-14 md:max-h-full md:items-start md:justify-start">
      <div
        className="absolute inset-0 z-0 rounded-3xl bg-right-top bg-no-repeat"
        style={{ backgroundImage: `url(${coverImageUrl})` }}
      >
        <div className="absolute inset-0 bg-black opacity-40 lg:hidden" />
      </div>

      <div className="relative z-10 flex w-full flex-col items-center md:max-w-[450px] md:items-start">
        {pillText && (
          <Pill
            theme={pillTheme}
            showDot={true}
            pulse={pillPulse}
            classes={`mt-0 rounded-lg border-[1.5px] text-white text-sm border-accent-focus border-${borderColor} bg-accent-hover bg-gradient-to-b from-accent-main to-accent-pressed`}
          >
            {pillText}
          </Pill>
        )}
        {headline && (
          <h4
            className={`z-10 mt-2 break-words bg-gradient-to-r from-uniqueFade-light to-white bg-clip-text pb-7 text-center font-gt-haptik font-bold leading-none text-transparent ${
              headline.length > 40
                ? 'text-heading-4 md:text-heading-3'
                : 'text-heading-3 md:text-heading-2'
            } md:text-left`}
          >
            {headline}
          </h4>
        )}
        <Button type={ButtonType.primary} size={ButtonSize.xs}>
          {lowerText}
        </Button>
      </div>
    </div>
  );

  return ctaLink ? (
    <Link
      href={ctaLink}
      passHref
      className="flex h-full w-full items-center justify-center"
    >
      <a>{content}</a>
    </Link>
  ) : (
    content
  );
};
